'use client';

import { useState, Suspense } from 'react';
import ExploreListings from '@/components/explore/explore-listings';
import ExploreMap from '@/components/explore/explore-map';
import FilterTopbar from '@/components/explore/filter-topbar';
import Filter from '@/components/explore/filter';
import Loader from '@/components/ui/loader/loader';
import { useSearchParams } from 'next/navigation';
import { useQueryParam } from '@/hooks/use-query-param';

export default function ExplorePage() {
  const [activeView, setActiveView] = useState('map'); // Default to Map View
  const toggleView = (view: string) => {
    setActiveView(view);
  };
  const { clearFilter, updateQueryparams } = useQueryParam();

  return (
    <div className="container-fluid mb-12 pt-6 lg:mb-16">
      <FilterTopbar />

      {/* Centering the buttons horizontally */}
      <div className="flex justify-center my-4 gap-4">
        <button
          onClick={() => toggleView('map')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            activeView === 'map'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-500 text-white'
          }`}
        >
          Map View
        </button>
        <button
          onClick={() => toggleView('list')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            activeView === 'list'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-500 text-white'
          }`}
        >
          List View
        </button>
      </div>

      <div className="grid grid-cols-1 gap-8 xl:grid-cols-[330px_5fr] 3xl:gap-12">
        <Suspense fallback={<Loader />}>
          <Filter className="hidden xl:block" />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <ExploreView activeView={activeView} />
        </Suspense>
      </div>
    </div>
  );
}

// Separate component to ensure useSearchParams is inside Suspense
function ExploreView({ activeView }: { activeView: string }) {
  const searchParams = useSearchParams();

  const location = searchParams.get('location');
  const departureDate = searchParams.get('departureDate');
  const returnDate = searchParams.get('returnDate');
  const types = searchParams.get('category');

  const paramsArray = Array.from(searchParams.entries()); // Convert params to an array

  console.log('All Params:', paramsArray);

  return activeView === 'map' ? (
    <ExploreMap
      location={location}
      types={types}
      departureDate={departureDate}
      returnDate={returnDate[1]}
    />
  ) : (
    <ExploreListings
      location={location}
      types={types}
      departureDate={departureDate}
      returnDate={returnDate[1]}
    />
  );
}
